import { devMessage } from "../devMessage/index";
export var devMessageIfUndefined = function(token, devMessageString) {
    if (typeof token === 'undefined') {
        devMessage(devMessageString);
        return undefined;
    }
    return token;
};
